<div class="auth-main">
    <div *ngIf="loading" class="auth-main__loader">
        <loader type="page" message="Загружаем ..."></loader>
    </div>
    <div class="auth-main__content" *ngIf="!loading">
        <img
            class="auth-main__mobile-logo"
            src="./assets/icons/auth/brand-logo.svg"
            alt="Логотип"
        />
        <div class="auth-main__title">
            <span>{{ AuthFormTitle }}</span>
        </div>
        <p class="auth-main__subtitle">Вход для пациента</p>
        <div
            class="login-mode-toggle"
            [ngClass]="{ 'tab-right': loginMode == 1 }"
            *ngIf="AuthType.includes('base') && AuthType.includes('sms')"
        >
            <button
                class="toggle-btn"
                [ngClass]="{ 'toggle-btn__active': loginMode == 0 }"
                (click)="changeLoginMode(0)"
            >
                <span class="toggle-btn__text">Пароль</span>
            </button>
            <button
                class="toggle-btn"
                [ngClass]="{ 'toggle-btn__active': loginMode == 1 }"
                (click)="changeLoginMode(1)"
            >
                <span class="toggle-btn__text">Номер телефона</span>
            </button>
        </div>
        <form
            (ngSubmit)="onSubmitBase()"
            [formGroup]="formBase"
            class="form"
            *ngIf="loginMode === 0"
            (keydown.enter)="focusNextInput($event)"
        >
            <label for="login">Логин *</label>
            <div class="form__field">
                <input
                    id="login"
                    name="username"
                    type="text"
                    formControlName="login"
                    autocomplete="username"
                    placeholder="Логин"
                    (input)="removeSpaces($event)"
                    #InputBlockLogin
                    [ngClass]="{
                        'invalid-input':
                            formBase.get('login')?.touched &&
                            formBase.get('login')?.invalid,
                    }"
                />
            </div>
            <label for="password">Пароль *</label>
            <div class="form__field">
                <input
                    id="password"
                    name="password"
                    [type]="hidePassword ? 'password' : 'text'"
                    formControlName="password"
                    autocomplete="current-password"
                    placeholder="Пароль"
                    (input)="removeSpaces($event)"
                    #InputBlockPass
                    [ngClass]="{
                        'invalid-input':
                            formBase.get('password')?.touched &&
                            formBase.get('password')?.invalid,
                    }"
                />
                <img
                    *ngIf="hidePassword"
                    src="./assets/icons/auth/show-password.svg"
                    alt="Показать пароль"
                    (click)="hidePassword = !hidePassword"
                />
                <img
                    *ngIf="!hidePassword"
                    src="./assets/icons/auth/hide-password.svg"
                    alt="Скрыть пароль"
                    (click)="hidePassword = !hidePassword"
                />
            </div>
            <div
                class="go-to-button"
                (click)="goToRecovery()"
                *ngIf="AccessRecovery"
            >
                Забыли пароль?
            </div>
            <div class="error-message" *ngIf="errorMessage">
                {{ errorMessage }}
            </div>
            <button
                mat-raised-button
                type="submit"
                [disabled]="formBase.invalid"
                class="form__submit"
            >
                <ng-container>Войти</ng-container>
                <ng-container>
                    <div class="form__submit-loader"></div>
                </ng-container>
            </button>
        </form>
        <form
            (ngSubmit)="onSubmitPhone()"
            [formGroup]="formPhone"
            class="form"
            *ngIf="loginMode === 1"
            (keydown.enter)="focusNextInput($event)"
        >
            <label>Номер телефона *</label>
            <div class="form__field">
                <input
                    id="phone"
                    type="tel"
                    formControlName="phone"
                    phoneMask
                    placeholder="+7 (___) ___-__-__"
                    #InputBlockPhone
                    [ngClass]="{
                        'invalid-input':
                            formPhone.get('phone')?.touched &&
                            formPhone.get('phone')?.invalid,
                    }"
                />
            </div>
            <div class="captcha-block">
                <div class="captcha-block__img">
                    <div
                        class="captcha__img"
                        [innerHTML]="captcha.svg | safe: 'html'"
                        *ngIf="!captchaLoad"
                    ></div>
                    <div *ngIf="captchaLoad" class="css-spinner"></div>

                    <button
                        class="captcha-block__refresh"
                        type="button"
                        (click)="refreshCaptcha()"
                    >
                        <mat-icon svgIcon="refresh"></mat-icon>
                    </button>
                </div>

                <div class="form__field">
                    <input
                        id="captcha"
                        type="string"
                        formControlName="captcha"
                        placeholder="Введите код с картинки"
                        maxlength="6"
                        (keydown.space)="$event.preventDefault()"
                        [ngClass]="{
                            'invalid-input':
                                formPhone.get('captcha')?.touched &&
                                formPhone.get('captcha')?.invalid,
                        }"
                    />
                </div>
            </div>
            <div class="error-message" *ngIf="errorMessage">
                {{ errorMessage }}
            </div>
            <button
                mat-raised-button
                type="submit"
                [disabled]="formPhone.invalid"
                class="form__submit"
            >
                <ng-container>Отправить код по СМС</ng-container>
                <ng-container>
                    <div class="form__submit-loader"></div>
                </ng-container>
            </button>
        </form>
        <button
            class="esia-button"
            type="submit"
            [disabled]="loading"
            *ngIf="esiaLink"
            (click)="loginEsia()"
        >
            <img src="./assets/icons/auth/esia.svg" class="icon" />
            Войти через Госуслуги
        </button>
        <div class="content-bottom">
            <div class="auth-main__register-hint" *ngIf="AccessReg">
                Впервые в личном кабинете?
            </div>
            <div
                class="go-to-button"
                (click)="goToRegistration()"
                *ngIf="AccessReg"
            >
                Регистрация
            </div>
        </div>

        <app-pwa-install-button
            class="auth-main__install"
            appearance="auth"
        ></app-pwa-install-button>
    </div>
    <div class="auth-main__img" *ngIf="!loading">
        <img class="img-logo" src="./assets/icons/auth/brand-logo.svg" alt="" />
        <img
            class="img-doctor"
            src="./assets/icons/auth/login-illustration.svg"
            alt=""
        />
    </div>
</div>

<!-- <ng-template #captchaBlock>
    <div class="captcha-block">
        <div 
            class="captcha-block__img" 
            *ngIf="captcha; else captchaLoader"
        >
            <div
                class="captcha__img"
                [innerHTML]="captcha.svg | safe : 'html'"
            ></div>

            <button
                class="captcha__refresh"
                type="button"
                (click)="refreshCaptcha()"
            >
                <mat-icon svgIcon="refresh"></mat-icon>
            </button>
        </div>
        <ng-template #captchaLoader>
            <div class="css-spinner"></div>
        </ng-template>
        <div class="form__field">
            <input
            id="captcha"
            type="string"
            formControlName="captcha"
            placeholder="Введите код с картинки"
            maxlength="10"
            (keydown.space)="$event.preventDefault()"
        />
        </div>
    </div>
</ng-template> -->

<!-- <div
    class="loading-group"
    [@showOpacityAnimation]="animState"
    (@showOpacityAnimation.done)="whenAnimate($event)"
>
    <div *ngIf="loading" class="loading loading-auth">
        <loader type="page"> </loader>
    </div>

    <form class="form-signin auth-form" [formGroup]="frm">
        <div *ngIf="showDoglist; then showListdog; else showAuthForm"></div>

        <ng-template #showListdog>
            <app-dog-list
                (onError)="onErrorDog($event)"
                [tmpToken]="tmpToken"
                [tokens]="tokens"
                [dogPREVIEW_REQUIRED]="dogPREVIEW_REQUIRED"
                (onEvent)="onEventDog($event)"
            ></app-dog-list>
        </ng-template>

        <ng-template #showAuthForm>
            <div *ngIf="Auth_type.includes('base') || Auth_type.includes('sms')">
                <mat-form-field class="w-100">
                    <input
                        id="asd"
                        [type]="'text'"
                        matInput
                        formControlName="username"
                        [readonly]="loading"
                        autofocus
                        (keyup.enter)="inputPassword.focus()"
                        autocomplete="username"
                    />
                    <mat-label>Логин</mat-label>
                </mat-form-field>

                <mat-form-field class="w-100" style="padding-top: 10px">
                    <mat-label>Пароль</mat-label>
                    <input
                        id="password1"
                        #inputPassword
                        [type]="hidePassword ? 'password' : 'text'"
                        matInput
                        formControlName="password"
                        autocomplete="current-password"
                    />
                    <span
                        *ngIf="!hidePassword"
                        matSuffix
                        (click)="hidePassword = !hidePassword"
                    >
                        <mat-icon svgIcon="password-visible"></mat-icon>
                    </span>

                    <span
                        *ngIf="hidePassword"
                        matSuffix
                        (click)="hidePassword = !hidePassword"
                    >
                        <mat-icon svgIcon="password-hidden"></mat-icon>
                    </span>
                </mat-form-field>

                <div class="cls-block-rec-save">
                    <mat-checkbox class="cls-save-my" color="primary"
                        >Запомнить меня</mat-checkbox
                    >
                    <div *ngIf="isRecovery; then showRecovery"></div>
                    <ng-template #showRecovery>
                        <a
                            href="./login/recovery"
                            class="cls-go-recovery"
                            title="Восстановление доступа к личному кабинету"
                            >Не помню пароль</a
                        >
                    </ng-template>
                </div>

                <button
                    class="w-100 btn btn-lg cls-btn cls-btn-auth"
                    type="submit"
                    [disabled]="
                        loading ||
                        !frm.valid ||
                        username.length < 3 ||
                        password.length < 3
                    "
                    (click)="trimInputsAndLogin()"
                >
                    Войти
                </button>
            </div>
            <button
                class="w-100 btn btn-lg cls-btn cls-btn-esia"
                type="submit"
                [disabled]="loading"
                *ngIf="esia_link"
                (click)="loginEsia()"
            >
                Войти через Госуслуги
            </button>

            <div class="cls-footer1" *ngIf="AccessReg">
                Первый раз в личном кабинете?
            </div>
            <div
                class="cls-footer2"
                (click)="goReg(1)"
                placeholder="Регистрацииия"
                *ngIf="AccessReg"
            >
                Регистрация
            </div>

            <div
                *ngIf="Auth_type === 'sms'"
                class="cls-footer2"
                (click)="goReg(3)"
                placeholder="Регистрация"
            >
                Вход по телефону
            </div>
        </ng-template>
    </form>
</div> -->
